import { PlanPrivacy, PlanType } from "common/app-plans";
import { getNamedIcon } from "common/named-icons";
import { GlideFC } from "lib/glide-fc";
import { styled } from "sharedUI/styles";

interface Props {
    plan: PlanType;
    privacy: PlanPrivacy;
    baseColor: string;
}

const AppPlanFeaturesContainer = styled.ul`
    list-style-type: none;
    li {
        height: 23px;
        display: flex;
        align-items: center;
        font-size: 11px;
        svg {
            margin-right: 4px;
        }
        .normal {
            margin-right: 4px;
        }
        .bold {
            font-weight: 700;
            margin-right: 4px;
        }
        .muted {
            color: ${p => p.theme.n800};
        }
    }
`;

const AppPlanFeatures: GlideFC<Props> = p => {
    const { plan, privacy, baseColor } = p;

    const ListCheck = getNamedIcon("listCheck");

    let features = <></>;
    if (plan === PlanType.Basic) {
        features = (
            <>
                <li>
                    <ListCheck fgColor={baseColor} />
                    <div className="bold">Mobile</div>
                    <div className="normal">Layout</div>
                </li>
                <li>
                    <ListCheck fgColor={baseColor} />
                    <div className="bold">5,000</div>
                    <div className="normal">data rows</div>
                </li>
                <li>
                    <ListCheck fgColor={baseColor} />
                    <div className="bold">5,000</div>
                    <div className="normal">sheet updates</div>
                </li>
                <li>
                    <ListCheck fgColor={baseColor} />
                    <div className="bold">Public</div>
                    <div className="normal">sign-in</div>
                </li>
                <li>
                    <ListCheck fgColor={baseColor} />
                    <div className="bold">5%</div>
                    <div className="normal">transaction fee</div>
                </li>
                <li>
                    <ListCheck fgColor={baseColor} />
                    <div className="bold">Minimal</div>
                    <div className="normal">Glide Branding</div>
                </li>
                <li>
                    <ListCheck fgColor={baseColor} />
                    <div className="bold">2GB</div>
                    <div className="normal">file storage</div>
                </li>
            </>
        );
    } else if (plan === PlanType.Pro && privacy === PlanPrivacy.Public) {
        features = (
            <>
                <li>
                    <ListCheck fgColor={baseColor} />
                    <div className="bold">Mobile, Tablet & Desktop</div>
                    <div className="normal">Layout</div>
                </li>
                <li>
                    <ListCheck fgColor={baseColor} />
                    <div className="bold">25,000</div>
                    <div className="normal">data rows</div>
                </li>
                <li>
                    <ListCheck fgColor={baseColor} />
                    <div className="bold">Unlimited</div>
                    <div className="normal">sheet updates</div>
                </li>
                <li>
                    <ListCheck fgColor={baseColor} />
                    <div className="bold">Public</div>
                    <div className="normal"> sign-in</div>
                </li>
                <li>
                    <ListCheck fgColor={baseColor} />
                    <div className="bold">2%</div>
                    <div className="normal">transaction fee</div>
                </li>
                <li>
                    <ListCheck fgColor={baseColor} />
                    <div className="bold">No</div>
                    <div className="normal">Glide Branding</div>
                </li>
                <li>
                    <ListCheck fgColor={baseColor} />
                    <div className="bold">10GB</div>
                    <div className="normal">file storage</div>
                </li>
                <li>
                    <ListCheck fgColor={baseColor} />
                    <div className="normal">Upload files up to</div>
                    <div className="bold">1GB</div>
                </li>
                <li>
                    <ListCheck fgColor={baseColor} />
                    <div className="bold">Custom Domain</div>
                </li>
                <li>
                    <ListCheck fgColor={baseColor} />
                    <div className="normal">Google Analytics</div>
                </li>
            </>
        );
    } else if (plan === PlanType.Pro && privacy === PlanPrivacy.Private) {
        const ListPlus = getNamedIcon("listPlus");
        const ListReturn = getNamedIcon("listReturn");
        features = (
            <>
                <li>
                    <ListReturn fgColor={baseColor} />
                    <div className="normal muted">...everything in pro</div>
                </li>
                <li>
                    <ListPlus fgColor={baseColor} />
                    <div className="bold">Private</div>
                    <div className="normal">sign-in</div>
                </li>
                <li>
                    <ListPlus fgColor={baseColor} />
                    <div className="bold">20 private users</div>
                    <div className="normal">included</div>
                </li>
                <li>
                    <ListPlus fgColor={baseColor} />
                    <div className="normal">Limit access by</div>
                    <div className="bold">password</div>
                </li>
                <li>
                    <ListPlus fgColor={baseColor} />
                    <div className="normal">Limit access by</div>
                    <div className="bold">email</div>
                </li>
                <li>
                    <ListPlus fgColor={baseColor} />
                    <div className="bold">Role-based</div>
                    <div className="normal">security</div>
                </li>
            </>
        );
    }

    return <AppPlanFeaturesContainer>{features}</AppPlanFeaturesContainer>;
};

export default AppPlanFeatures;
